import React from 'react'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { Ico } from '@/components/icons'
import { useLang } from '@/lib/lang'

export default function ActiveVisit() {
  const { t } = useLang()
  const av = t.acct.active_visit

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.visits, av.visit_name]}/>
        <div className="content">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 18 }}>
            <div>
              <span className="status-pill pill-live"><span className="dot"/>{av.live_pill}</span>
              <h1 className="h-display" style={{ fontSize: 40, margin: "12px 0 0" }}>
                {av.miles_away_pre} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{av.miles_away_word}</span> {av.miles_away_post}
              </h1>
              <p style={{ fontSize: 15, color: "var(--muted)", margin: "6px 0 0" }}>
                {av.blurb}
              </p>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="btn btn-ghost" style={{ padding: "10px 16px", fontSize: 13 }}><Ico.phone/> {av.call_rico}</button>
              <button className="btn btn-primary" style={{ padding: "10px 16px", fontSize: 13 }}><Ico.msg/> {av.message_crew}</button>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18 }}>
            {/* Map */}
            <div className="tile" style={{ padding: 0, overflow: "hidden", position: "relative", aspectRatio: "1.6" }}>
              <svg viewBox="0 0 600 380" style={{ width: "100%", height: "100%", display: "block", background: "var(--cocoa-2)" }}>
                <defs>
                  <pattern id="map-grid" width="30" height="30" patternUnits="userSpaceOnUse">
                    <path d="M30 0L0 0 0 30" fill="none" stroke="rgba(245,239,230,0.05)" strokeWidth="0.5"/>
                  </pattern>
                  <linearGradient id="vanBody" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FAF1DE"/>
                    <stop offset="50%" stopColor="#E8DDC9"/>
                    <stop offset="100%" stopColor="#B0A38C"/>
                  </linearGradient>
                  <linearGradient id="vanWindow" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#1F1610"/>
                    <stop offset="100%" stopColor="#5A4736"/>
                  </linearGradient>
                  <filter id="vanShadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="1.4"/>
                  </filter>
                </defs>
                <rect width="600" height="380" fill="url(#map-grid)"/>
                <path d="M0 80 L600 80M0 200 L600 200M0 320 L600 320" stroke="rgba(245,239,230,0.1)" strokeWidth="3"/>
                <path d="M150 0 L150 380M380 0 L380 380M520 0 L520 380" stroke="rgba(245,239,230,0.1)" strokeWidth="3"/>
                <path d="M0 140 L600 140M0 260 L600 260" stroke="rgba(245,239,230,0.06)" strokeWidth="1.5"/>
                <path d="M250 0 L250 380M450 0 L450 380" stroke="rgba(245,239,230,0.06)" strokeWidth="1.5"/>

                {[
                  [50,30,80,40],[160,30,70,40],[260,30,70,40],[390,30,70,40],
                  [60,90,80,40],[170,90,70,40],[270,90,60,40],[395,90,50,40],[460,90,50,40],
                  [50,210,80,40],[160,210,70,40],[460,210,55,40],
                  [60,270,80,40],[260,270,60,40],
                ].map(([x,y,w,h], i) => <rect key={i} x={x} y={y} width={w} height={h} fill="rgba(245,239,230,0.04)" stroke="rgba(245,239,230,0.08)"/>)}

                <path id="route" d="
                  M 520 50
                  L 520 182
                  Q 520 200 502 200
                  L 398 200
                  Q 380 200 380 218
                  L 380 302
                  Q 380 320 362 320
                  L 220 320
                  L 200 340
                " stroke="#E68A5C" strokeWidth="3" fill="none" strokeDasharray="6 4" className="moving-dash" strokeLinecap="round" strokeLinejoin="round"/>

                <g>
                  <circle r="16" fill="none" stroke="#E68A5C" strokeWidth="1.2" opacity="0.55">
                    <animate attributeName="r" from="14" to="28" dur="1.8s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" from="0.7" to="0" dur="1.8s" repeatCount="indefinite"/>
                  </circle>
                  <ellipse cx="0" cy="5" rx="15" ry="5" fill="rgba(0,0,0,0.55)" filter="url(#vanShadow)"/>
                  <rect x="-14" y="-7" width="28" height="14" rx="3.5" fill="url(#vanBody)" stroke="rgba(58,42,31,0.7)" strokeWidth="0.5"/>
                  <rect x="-12" y="-1.5" width="24" height="3" rx="1.2" fill="rgba(255,251,239,0.35)"/>
                  <path d="M 9.5,-5.6 L 13,-3 L 13,3 L 9.5,5.6 Z" fill="url(#vanWindow)"/>
                  <path d="M -9.5,-4.2 L -12,-2 L -12,2 L -9.5,4.2 Z" fill="url(#vanWindow)" opacity="0.85"/>
                  <rect x="-7"  y="-6"   width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="-3"  y="-6"   width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="1"   y="-6"   width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="5"   y="-6"   width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="-7"  y="4"    width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="-3"  y="4"    width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="1"   y="4"    width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="5"   y="4"    width="3" height="2" rx="0.4" fill="url(#vanWindow)" opacity="0.78"/>
                  <rect x="-11" y="-0.6" width="22" height="1.2" fill="#C2552D"/>
                  <text x="0" y="0.5" textAnchor="middle" fontFamily="'Geist Mono', monospace" fontSize="1.8" fontWeight="700" fill="#FAF6EF" style={{ letterSpacing: "0.05em" }}>FMC</text>
                  <circle cx="13.7" cy="-4" r="0.8" fill="#FFE4B0"/>
                  <circle cx="13.7" cy="4"  r="0.8" fill="#FFE4B0"/>
                  <rect x="-14.3" y="-4.5" width="0.6" height="2" fill="#9C2E18"/>
                  <rect x="-14.3" y="2.5"  width="0.6" height="2" fill="#9C2E18"/>
                  <animateMotion dur="16s" repeatCount="indefinite" rotate="auto" keyPoints="0;1" keyTimes="0;1" calcMode="spline" keySplines="0.4 0 0.6 1">
                    <mpath href="#route"/>
                  </animateMotion>
                </g>

                <g transform="translate(200, 340)">
                  <circle r="10" fill="#7A8C6C"/>
                  <circle r="14" fill="none" stroke="#7A8C6C" strokeWidth="1.5"/>
                  <text y="-18" textAnchor="middle" fontFamily="'Geist Mono'" fontSize="10" fill="#FAF6EF" fontWeight="600">{av.your_home}</text>
                </g>

                <g transform="translate(520, 50)">
                  <circle r="4" fill="rgba(245,239,230,0.5)"/>
                  <text y="-10" textAnchor="middle" fontFamily="'Geist Mono'" fontSize="9" fill="rgba(245,239,230,0.6)">{av.shop}</text>
                </g>

                <text x="588" y="370" textAnchor="end" fontFamily="'Geist Mono'" fontSize="9" fill="rgba(245,239,230,0.3)">CORAL GABLES · MIAMI</text>
              </svg>

              {/* Floating ETA card */}
              <div className="map-card" style={{
                left: 12, top: 12,
                padding: "8px 14px 10px",
                display: "flex", flexDirection: "column", alignItems: "center",
                minWidth: 110,
              }}>
                <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)", letterSpacing: "0.14em", marginBottom: 1 }}>
                  {av.arrives}
                </div>
                <div className="font-display" style={{
                  fontSize: 20, fontWeight: 600, color: "var(--cocoa)",
                  letterSpacing: "-0.01em", lineHeight: 1.05,
                }}>
                  {av.eta_time}<span style={{ fontSize: 11, fontWeight: 500, marginLeft: 3, color: "var(--muted)" }}>AM</span>
                </div>
                <div style={{
                  marginTop: 4, padding: "2px 8px",
                  background: "rgba(194,85,45,0.12)",
                  borderRadius: 999,
                  color: "var(--terracotta)",
                  fontFamily: "'Geist Mono', monospace",
                  fontSize: 9, fontWeight: 700, letterSpacing: "0.05em",
                  display: "flex", alignItems: "center", gap: 4,
                }}>
                  <span style={{
                    width: 4, height: 4, borderRadius: "50%",
                    background: "var(--terracotta)",
                    animation: "pulse-dot 1.4s infinite",
                  }}/>
                  {av.in_8_min}
                </div>
              </div>

              {/* Floating crew card */}
              <div className="map-card" style={{
                right: 12, bottom: 12,
                padding: "9px 12px",
                display: "flex", gap: 9, alignItems: "center",
              }}>
                <div style={{
                  width: 32, height: 32, borderRadius: "50%",
                  background: "var(--terracotta)",
                  color: "var(--cream)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 600, fontSize: 12,
                  flexShrink: 0,
                }}>RC</div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--cocoa)", lineHeight: 1.2 }}>{av.crew_name}</div>
                  <div className="font-mono" style={{ fontSize: 9, color: "var(--muted)", marginTop: 1 }}>{av.crew_meta}</div>
                </div>
              </div>
            </div>

            {/* Timeline */}
            <div className="tile" style={{ padding: 22 }}>
              <div className="kicker accent" style={{ marginBottom: 12 }}>◆ {av.eyebrow}</div>
              <h3 className="h-display" style={{ fontSize: 20, margin: "0 0 16px" }}>{av.timeline_title}</h3>

              <div style={{ display: "flex", flexDirection: "column", gap: 0, position: "relative" }}>
                <div style={{ position: "absolute", left: 11, top: 12, bottom: 12, width: 2, background: "var(--line)" }}/>
                {[
                  { t: "9:32 AM", s: av.step1, state: "done" },
                  { t: "9:48 AM", s: av.step2, state: "done" },
                  { t: "10:00 AM", s: av.step3, state: "done" },
                  { t: "10:08 AM", s: av.step4, state: "active" },
                  { t: "10:10 AM", s: av.step5, state: "next" },
                  { t: "12:30 PM", s: av.step6, state: "next" },
                ].map((step, i) => (
                  <div key={i} style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 14, padding: "8px 0", position: "relative", zIndex: 1, alignItems: "center" }}>
                    <div style={{
                      width: 24, height: 24, borderRadius: "50%",
                      background: step.state === "done" ? "var(--sage)" : step.state === "active" ? "var(--terracotta)" : "var(--cream)",
                      border: step.state === "next" ? "2px solid var(--line-strong)" : "none",
                      color: "var(--cream)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      boxShadow: step.state === "active" ? "0 0 0 4px rgba(194,85,45,0.18)" : "none",
                    }}>
                      {step.state === "done" && <Ico.check width="12" height="12"/>}
                      {step.state === "active" && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--cream)", animation: "pulse-dot 1s infinite" }}/>}
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: step.state === "active" ? 600 : 400, color: step.state === "next" ? "var(--muted)" : "var(--cocoa)" }}>{step.s}</div>
                      <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{step.t.toUpperCase()}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop: 18, padding: 14, background: "var(--cream-2)", borderRadius: 12, fontSize: 12, color: "var(--muted)", lineHeight: 1.5 }}>
                <div className="font-mono" style={{ fontSize: 10, color: "var(--cocoa)", marginBottom: 6 }}>{av.expect_today_label}</div>
                {av.expect_today_body}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
